import {
  CREATE_ELITE_OFFER,
  UPDATE_ELITE_OFFER,
  UNLOAD_ELITE_OFFER,
  ELITE_OFFER_FETCHED_SUCCESS,
  RESET_ELITE_OFFER,
} from '../constants/actionTypes';

const initialState = {
  offers: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ELITE_OFFER:
    case UPDATE_ELITE_OFFER:
      return {
        ...state,
        message: action.payload.msg,
      };

    case RESET_ELITE_OFFER:
      return {
        ...state,
        message: '',
      };

    case ELITE_OFFER_FETCHED_SUCCESS:
      return {
        ...state,
        offers: action.payload.offers.map((item) => {
          const newItem = { ...item, _id: item._id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    case UNLOAD_ELITE_OFFER:
      return initialState;

    default:
      return state;
  }
};
